import React from "react";
import "../styles/About.css";
import portraitImage from "../assets/img/portrait.jpg";

const About = ({ about }) => {
  return (
    <section id="about" className="about">
      <div className="about__container">
        <div className="about__portrait-section wow animate__animated animate__fadeInLeft">
          <div className="about__portrait-frame">
            <img
              src={portraitImage}
              alt={about.name}
              className="about__portrait"
            />
          </div>
        </div>

        <div className="about__info-section wow animate__animated animate__fadeInRight">
          <span className="about__greeting">{about.greeting}</span>
          <h1 className="about__name">{about.name}</h1>
          <h2 className="about__title">{about.title}</h2>
          <p className="about__tagline">{about.tagline}</p>

          <div className="about__card">
            <div className="about__card-icon">
              <i className="fas fa-graduation-cap"></i>
            </div>
            <div className="about__card-content">
              <span className="about__card-label">{about.educationLabel}</span>
              <span className="about__card-value">{about.university}</span>
              <span className="about__card-sub">
                {about.major} · {about.minorLabel} {about.minor}
              </span>
            </div>
          </div>

          <div className="about__actions">
            <a href={`mailto:${about.email}`} className="about__action-btn about__action-btn--primary">
              <i className="fas fa-envelope"></i>
              <span>{about.ctaLabel}</span>
            </a>
            <a
              href={about.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="about__action-btn"
            >
              <i className="fab fa-linkedin"></i>
              <span>LinkedIn</span>
            </a>
            <a
              href={about.github}
              target="_blank"
              rel="noopener noreferrer"
              className="about__action-btn"
            >
              <i className="fab fa-github"></i>
              <span>GitHub</span>
            </a>
          </div>

          <div className="about__contact-info">
            <a href={`mailto:${about.email}`} className="about__contact-link">
              <i className="fas fa-envelope"></i>
              {about.email}
            </a>
            {about.phone && (
              <a href={`tel:${about.phone.replace(/\D/g, "")}`} className="about__contact-link">
                <i className="fas fa-phone"></i>
                {about.phone}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
